import { ServiceLocationHierarchy, ServiceObject } from '../@types/service.type';

/**
 * Walk the location hierarchy to find the outlet (physical location) name.
 * The outlet can sit at any depth below the client/contract nodes, so this
 * recurses rather than reading a fixed level.
 */
const findOutletName = (node?: ServiceLocationHierarchy | null): string => {
  if (!node) return '';
  if (node.nodeTypeCode === 'outlet') return node.name ?? '';
  for (const child of node.children ?? []) {
    const found = findOutletName(child);
    if (found) return found;
  }
  return '';
};

/**
 * The human-readable location for a job: the outlet name from the hierarchy,
 * falling back to the flat `mainLocation` string when the hierarchy hasn't
 * loaded or carries no outlet node. Returns '' when neither is available.
 *
 * Shared by the SummaryBar title and the browser tab title so both name the
 * same place.
 */
export const getServiceLocationName = (service?: ServiceObject | null): string =>
  findOutletName(service?.locationHierarchy) || service?.mainLocation || '';
